import type { RouteRecordRaw } from 'vue-router'
import { INDEX_LAYOUT, PAGE_LAYOUT } from '@/router/constant'

/** 球员榜 */
const players: RouteRecordRaw = {
  path: '/players-page',
  name: 'players-page',
  component: PAGE_LAYOUT,
  children: [
    {
      path: '/players-layout',
      name: 'players-layout',
      component: INDEX_LAYOUT,
      redirect: '/players',
      children: [
        {
          path: '/players',
          name: 'players',
          meta: {
            title: '球员榜',
            keepAlive: true,
          },
          component: () => import('@/views/users/index.vue'),
        },
      ],
    },
  ],
}

export default players
